"use strict";

exports.__esModule = true;
var _AlertsContext = require("./AlertsContext");
Object.keys(_AlertsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertsContext[key]) return;
  exports[key] = _AlertsContext[key];
});
var _AlertsController = require("./AlertsController");
Object.keys(_AlertsController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertsController[key]) return;
  exports[key] = _AlertsController[key];
});